import { postEntityData } from "../../../helpers/AuthType/authBackend";

// action
import { registerEntitySuccessful, registerEntityFailed } from "./reducer";

// Is user register successfull then direct plot user in redux.
export const registerEntity =
  (user: any, history: any) => async (dispatch: any) => {
    try {
      let response: any;

      if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
        // response = postEntityData(user);
        const data: any = await response;
        console.log(user);
        //Extraer el id del negocio creado y meterlo en el locaStorage pero encriptado
        dispatch(registerEntitySuccessful(user));
      }
      history("/registerform");
    } catch (error) {
      dispatch(registerEntityFailed(error));
    }
  };
